// src/stores/ui.js

import { defineStore } from 'pinia'
import axios from 'axios'

const apiBaseURL = process.env.VUE_APP_API_URL || 'https://localhost:7075/api'

export const useUiStore = defineStore('ui', {
  /**
   * State: Onde os dados da sua store vivem.
   */
  state: () => ({
    // --- Estados existentes ---
    currentModule: null,
    currentModuleTitle: '',
    currentModulePerms: [], // Array de strings MODULO_CHAVE do módulo ativo (ex: ['IMPORTACAO_VISUALIZACAO'])
    currentModuleExtraProps: {}, // Objeto com props extras passadas via menuConfig (ex: { tipoOperacao: 'COMEX_TP_OPER1' })
    isFormPanelOpen: false,
    itemSelecionadoParaEdicao: null,

    // --- NOVOS ESTADOS para Admin Interno ---
    listaEmpresasParaSelecao: [], // Guarda a lista { id, nome } das empresas
    targetIdEmpresaSelecionada: null, // Guarda o ID da empresa selecionada pelo admin

    // --- NOVO ESTADO: Controla qual menu está visível no sidebar ---
    activeMenu: 'main', // 'main', 'parametros', etc.

    // --- CONTADOR DE REQUISIÇÕES HTTP (Loading Global) ---
    // Incrementado no request interceptor, decrementado no response/error.
    // Usado pelo GlobalLoadingOverlay para exibir "Aguarde..." automaticamente.
    apiCallCount: 0
  }),

  /**
   * Getters: Equivalentes às computed properties.
   */
  getters: {
    isEditing: (state) => state.itemSelecionadoParaEdicao !== null,

    // Getter opcional para facilitar o acesso ao ID selecionado
    empresaSelecionadaId: (state) => state.targetIdEmpresaSelecionada,

    // --- LOADING GLOBAL ---
    // Retorna true quando há pelo menos uma requisição HTTP em andamento
    isLoading: (state) => state.apiCallCount > 0
  },

  /**
   * Actions: Equivalentes aos methods.
   */
  actions: {
    // --- Ações existentes ---
    selecionarModulo (moduleName, moduleTitle, perms = [], extraProps = {}) {
      this.currentModule = moduleName
      this.currentModuleTitle = moduleTitle || ''
      this.currentModulePerms = perms
      this.currentModuleExtraProps = extraProps
      this.fecharPainelFormulario()

      // Atualiza a aba do navegador conforme o módulo ativo
      document.title = moduleTitle
        ? `CTech - ${moduleTitle}`
        : 'CTech'
    },

    abrirPainelFormulario (item = null) {
      this.itemSelecionadoParaEdicao = item
      this.isFormPanelOpen = true
    },

    fecharPainelFormulario () {
      this.isFormPanelOpen = false
      this.itemSelecionadoParaEdicao = null
    },

    // --- Ações para Admin Interno ---
    async buscarEmpresasParaSelecao () {
      if (this.listaEmpresasParaSelecao.length > 0) return

      try {
        // Usa axios direto em vez de api (services/api) para evitar
        // circular dependency com api.js (que importa esta store).
        const response = await axios.get(`${apiBaseURL}/Empresas/Lookup`)
        this.listaEmpresasParaSelecao = response.data
      } catch (error) {
        console.error('Erro ao buscar lista de empresas para seleção:', error)
        this.listaEmpresasParaSelecao = []
      }
    },

    selecionarTargetEmpresa (idEmpresa) {
      // Converte para null se for undefined ou string vazia, e para número se for string numérica
      const novoId = (idEmpresa === undefined || idEmpresa === '') ? null : Number(idEmpresa)

      if (this.targetIdEmpresaSelecionada !== novoId) {
        this.targetIdEmpresaSelecionada = novoId
        // TODO: Adicionar lógica para recarregar o módulo atual, se necessário
      }
    },

    // --- NOVA AÇÃO: Para trocar os menus ---
    setActiveMenu (menuName) {
      this.activeMenu = menuName
    }
  }
})
